const sculptures = {
  items: [{
    id: "71",
    title: 'Фигурка "Пантера", 1930 год, Франция, Керамическая фабрика г. Сен-Клеман, автор – Шарль Лемансо, керамика, высота – 13 см, длина – 40 см.',
    img: "_DSC7307",
    view: "1",
    author: "LEMANCEAU CHARLES",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "72",
    title: 'Фигурка "Пантера", 1930-е годы, Франция, автор – Сигль, керамика, высота – 14 см, длина – 28 см.',
    img: "CHE_2056",
    view: "1",
    author: "Siegl",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "61",
    title: 'Фигурка "Львица", 1930-е годы, Франция, авторы – ОДИВ (Одетта Берло и Ивонн Мюсье), керамика, высота – 19 см, длина – 32 см.',
    img: "VCH_5192",
    view: "1",
    author: "ODYV (Odette Berlot & Yvonne Mussier)",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "13",
    title: 'Скульптура "Кошки", 1930-е годы, Бельгия, автор – Анджело Хек, керамика, высота – 27 см, длина – 38 см.',
    img: "CHE_7249",
    view: "1",
    author: "HECQ ANGELO",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "33",
    title: 'Скульптура "Пантера", 1930-е годы, Франция, заказчик - Primavera (студия дизайна парижского универмага Printemps), керамика, высота – 20 см, длина – 60 см.',
    img: "CHE_2083",
    view: "1",
    author: "PRIMAVERA",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "designStudio",
    designStudio: "0",
    factories: "0"
  }, {
    id: "25",
    title: 'Скульптура "Пантера", 1930-е годы, Франция, Керамическая фабрика г. Малакоф, автор – Д\'Ерна, керамика, высота – 14 см, длина – 66 см.',
    img: "_DSC7336",
    view: "1",
    author: "D\u2019Yerna",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "19",
    title: 'Скульптура "Пантера у куста", 1930-е годы, Франция, Керамическая фабрика г. Орши, авторы – Лежан (Ивонн Жан-Афен и Эльвира Куюмуджан), керамика, высота – 29 см, длина – 54 см.',
    img: "CHE_2008",
    view: "1",
    author: "Lejan (Yvonne Jean-Haffen & Elvire Kouyoumojian)",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "21",
    title: 'Скульптура "Пантера", 1930-е годы, Франция, автор – Е. Пьер, заказчик - Primavera (студия дизайна парижского универмага Printemps), керамика, высота – 33 см, длина – 76 см.',
    img: "CHE_7247",
    view: "1",
    author: "Pierre E.",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "72-1",
    title: "\u0421\u043a\u0443\u043b\u044c\u043f\u0442\u0443\u0440\u0430 '\u041f\u0430\u043d\u0442\u0435\u0440\u0430' (\u043d\u0430 \u043f\u043b\u0438\u043d\u0442\u0435), 1930-\u0435 \u0433\u043e\u0434\u044b, \u0424\u0440\u0430\u043d\u0446\u0438\u044f, \u041a\u0435\u0440\u0430\u043c\u0438\u0447\u0435\u0441\u043a\u0430\u044f \u0444\u0430\u0431\u0440\u0438\u043a\u0430 \u0433. \u041c\u0430\u043b\u0430\u043a\u043e\u0444, \u0430\u0432\u0442\u043e\u0440 \u2013 \u0414'\u0415\u0440\u043d\u0430, \u043a\u0435\u0440\u0430\u043c\u0438\u043a\u0430, \u0432\u044b\u0441\u043e\u0442\u0430 \u2013 35 \u0441\u043c, \u0434\u043b\u0438\u043d\u0430 \u2013 85 \u0441\u043c.",
    img: "CHE_6138",
    view: "1",
    author: "D\u2019Yerna",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "72-1",
    title: "\u0421\u043a\u0443\u043b\u044c\u043f\u0442\u0443\u0440\u0430 '\u041f\u0430\u043d\u0442\u0435\u0440\u0430 \u043d\u0430 \u0441\u043a\u0430\u043b\u0435', 1930-\u0435 \u0433\u043e\u0434\u044b, \u0424\u0440\u0430\u043d\u0446\u0438\u044f, \u041a\u0435\u0440\u0430\u043c\u0438\u0447\u0435\u0441\u043a\u0430\u044f \u0444\u0430\u0431\u0440\u0438\u043a\u0430 \u0433. \u041c\u0430\u043b\u0430\u043a\u043e\u0444, \u0430\u0432\u0442\u043e\u0440 \u2013 \u0414'\u0415\u0440\u043d\u0430, \u043a\u0435\u0440\u0430\u043c\u0438\u043a\u0430, \u0432\u044b\u0441\u043e\u0442\u0430 \u2013 23 \u0441\u043c, \u0434\u043b\u0438\u043d\u0430 \u2013 46 \u0441\u043c.",
    img: "CHE_6141",
    view: "1",
    author: "D\u2019Yerna",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "23",
    title: 'Скульптура "Пантера", 1930-е годы, Франция, авторы – Лежан (Ивонн Жан-Афен и Эльвира Куюмуджан), терракота, высота – 29 см, длина – 56 см.',
    img: "_DSC7337",
    view: "1",
    author: "Lejan (Yvonne Jean-Haffen & Elvire Kouyoumojian)",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "20",
    title: 'Скульптура "Пантера" (на плинте), 1930-е годы, Франция, Керамическая фабрика г. Малакоф, автор – Д\'Ерна, керамика, высота – 35 см, длина – 85 см.',
    img: "CHE_2101",
    view: "1",
    author: "D\u2019Yerna",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "56",
    title: '\u0424\u0438\u0433\u0443\u0440\u043a\u0430 "\u041a\u043e\u0448\u043a\u0430", 1930 \u0433\u043e\u0434, \u0424\u0440\u0430\u043d\u0446\u0438\u044f, \u041a\u0435\u0440\u0430\u043c\u0438\u0447\u0435\u0441\u043a\u0430\u044f \u0444\u0430\u0431\u0440\u0438\u043a\u0430 \u0433. \u0421\u0435\u043d-\u041a\u043b\u0435\u043c\u0430\u043d, \u0430\u0432\u0442\u043e\u0440 \u2013 \u0428\u0430\u0440\u043b\u044c \u041b\u0435\u043c\u0430\u043d\u0441\u043e, \u043a\u0435\u0440\u0430\u043c\u0438\u043a\u0430, \u0432\u044b\u0441\u043e\u0442\u0430 \u2013 29 \u0441\u043c, \u0434\u043b\u0438\u043d\u0430 \u2013 16 \u0441\u043c.',
    img: "_DSC7304",
    view: "1",
    author: "LEMANCEAU CHARLES",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "11",
    title: 'Скульптура "Кошка", 1926 год, Франция, Севрская фарфоровая мануфактура, авторы – Жан и Жоэль Мартель, фарфор, высота – 34 см, длина – 20 см.',
    img: "CHE_1980",
    view: "1",
    author: "Martel Jan & Joel",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "10",
    title: 'Скульптура "Кошка", 1920-е годы, Франция, Парижская фарфоровая мануфактура, автор – Эдуард-Марсель Сандоз, фарфор, высота – 35 см, длина – 23 см.',
    img: "CHE_1974",
    view: "1",
    author: "Sandoz Edouard-Marcel",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "12",
    title: 'Скульптура "Кошка", 1930-е годы, Франция, автор – Лиз Тавернье, заказчик - студия дизайна Kaza, керамика, высота – 39 см, длина – 18 см.',
    img: "CHE_7186",
    view: "1",
    author: "Tavernier Lise",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "58",
    title: 'Фигурка "Кошка", 1930-е годы, Франция, автор – Жак Адне, керамика, высота – 34 см, длина – 28 см.',
    img: "CHE_1991",
    view: "1",
    author: "Adnet Jacques",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "55",
    title: 'Фигурка "Кошка", 1920-е годы, Франция, Лиможская фарфоровая мануфактура, автор – Камиль Таро, фарфор, высота – 21 см, длина – 11 см.',
    img: "CHE_6269",
    view: "1",
    author: "Tharaud Camille",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "54",
    title: 'Фигурка "Кошка с катушкой", 1930-е годы, Франция, заказчик - Compagnie des Arts francais, керамика, высота – 25 см, длина – 8 см.',
    img: "CHE_7270",
    view: "1",
    author: "CAF (Compagnie des Arts francais)",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "designStudio",
    designStudio: "0",
    factories: "0"
  }, {
    id: "9",
    title: 'Скульптура "Кошка", 1920 год, Франция, автор – Эдуард Шазан, заказчик - Primavera (студия дизайна парижского универмага Printemps), керамика, высота – 60 см, длина – 35 см.',
    img: "CHE_1959",
    view: "1",
    author: "Chassaing Edouard",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "57",
    title: 'Фигурка "Кошка", 1930-е годы, Бельгия, Императорская и Королевская мануфактура г. Ними, автор – Альберт Аебли, керамика, высота – 25 см, длина – 16 см.',
    img: "CHE_2042",
    view: "1",
    author: "Aebly Albert",
    creator: "animalism",
    type: "cat",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "43",
    title: 'Фигурка "Белый медведь", 1930-е годы, Бельгия, фарфоровая мануфактура "Серабель" (г. Бодур), керамика, высота – 16 см, длина – 33 см.',
    img: "_DSC7312",
    view: "1",
    author: "CERABEL",
    creator: "animalism",
    type: "bear",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "4",
    title: 'Скульптура "Белый медведь", 1930-е годы, Франция, автор – Жан де Ла Фонтинель, керамика, высота – 20 см, длина – 40 см.',
    img: "_DSC7299",
    view: "1",
    author: "Fontinelle Jean de La",
    creator: "animalism",
    type: "bear",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "5",
    title: 'Скульптура "Белый медведь", 1930-е годы, Франция, авторы – Лежан (Ивонн Жан-Афен и Эльвира Куюмуджан), керамика, высота – 34 см, длина – 62 см.',
    img: "_DSC7298",
    view: "1",
    author: "Lejan (Yvonne Jean-Haffen & Elvire Kouyoumojian)",
    creator: "animalism",
    type: "bear",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "3",
    title: 'Скульптура "Белый медведь", 1930-е годы, Франция, автор – Дебарбьё, керамика, высота – 36 см, длина – 47 см.',
    img: "_DSC7319",
    view: "1",
    author: "Desbarbieux",
    creator: "animalism",
    type: "bear",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "65",
    title: 'Фигурка "Медведь", 1930-е годы, Бельгия, Императорская и Королевская мануфактура г. Ними, керамика, высота – 15 см, длина – 19 см.',
    img: "CHE_7286",
    view: "1",
    author: "Manufacture Imperiale et Royale Nimy",
    creator: "animalism",
    type: "bear",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "66",
    title: 'Фигурка "Медведь", 1930-е годы, Бельгия, Императорская и Королевская мануфактура г. Ними, керамика, высота – 15 см, длина – 19 см.',
    img: "CHE_7289",
    view: "1",
    author: "Manufacture Imperiale et Royale Nimy",
    creator: "animalism",
    type: "bear",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "64",
    title: 'Фигурка "Медведь", 1930-е годы, Бельгия, Императорская и Королевская мануфактура г. Ними, керамика, высота – 15 см, длина – 19 см.',
    img: "CHE_1552",
    view: "1",
    author: "Manufacture Imperiale et Royale Nimy",
    creator: "animalism",
    type: "bear",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "95",
    title: 'Фигурки "Медведь", 1930-е годы, Бельгия, Императорская и Королевская мануфактура г. Ними, керамика, высота – 15 см, длина – 19 см.',
    img: "CHE_1555",
    view: "1",
    author: "Manufacture Imperiale et Royale Nimy",
    creator: "animalism",
    type: "bear",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "42",
    title: 'Фигурка "Белый медведь на льдине", 1930-е годы, Франция, Керамическая фабрика Андре Фо (Булонь-Сюр-Сен), автор – Айэрлэнд, керамика, высота – 27 см, длина – 35 см.',
    img: "CHE_2034",
    view: "1",
    author: "Ireland",
    creator: "animalism",
    type: "bear",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "67",
    title: 'Фигурка "Медведь", 1930-е годы, Бельгия, фарфоровая мануфактура "Серабель" (г. Бодур), керамика, высота – 19 см, длина – 13 см.',
    img: "_DSC7302",
    view: "1",
    author: "CERABEL",
    creator: "animalism",
    type: "bear",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "2",
    title: 'Скульптура "Белый медведь" (на плинте), 1934 год, Франция, Керамическая фабрика г. Орши, авторы – Лежан (Ивонн Жан-Афен и Эльвира Куюмуджан), керамика, высота – 23 см, длина – 43 см.',
    img: "CHE_7255",
    view: "1",
    author: "Lejan (Yvonne Jean-Haffen & Elvire Kouyoumojian)",
    creator: "animalism",
    type: "bear",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "96",
    title: "\u0424\u0438\u0433\u0443\u0440\u043a\u0430 \xab\u041f\u043e\u043f\u0443\u0433\u0430\u0439\xbb, 1930-\u0435 \u0433\u043e\u0434\u044b, \u041d\u0438\u0434\u0435\u0440\u043b\u0430\u043d\u0434\u044b, \u041a\u043e\u0440\u043e\u043b\u0435\u0432\u0441\u043a\u0430\u044f \u043a\u0435\u0440\u0430\u043c\u0438\u0447\u0435\u0441\u043a\u0430\u044f \u0444\u0430\u0431\u0440\u0438\u043a\u0430 \u042e\u0436\u043d\u043e\u0439 \u0413\u043e\u043b\u043b\u0430\u043d\u0434\u0438\u0438 (\u0433. \u0413\u0430\u0443\u0434\u0430), \u043a\u0435\u0440\u0430\u043c\u0438\u043a\u0430, \u0432\u044b\u0441\u043e\u0442\u0430 \u2013 23 \u0441\u043c, \u0434\u043b\u0438\u043d\u0430 \u2013 14 \u0441\u043c.",
    img: "CHE_6172",
    view: "3",
    author: "N.V. KONINKLIJKE PLATEELBAKKERIJ ZUID-HOLLAND, GOUDA",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "0"
  }, {
    id: "49",
    title: 'Фигурка "Голубь", 1930 год, Бельгия, Керамическая фабрика братьев Бох, автор – Шарль Като, керамика, высота – 23 см, длина – 19 см.',
    img: "CHE_2021",
    view: "1",
    author: "Catteau Charles",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "53",
    title: 'Фигурка "Колибри", 1930 год, Бельгия, Керамическая фабрика братьев Бох, автор – Шарль Като, керамика, высота – 17 см, длина – 13 см.',
    img: "CHE_1547",
    view: "1",
    author: "Catteau Charles",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "92",
    title: 'Фигурка "Чайка", 1928 год, Франция, автор – Жак Адне, керамика, высота – 30 см, длина – 27 см.',
    img: "CHE_7258",
    view: "1",
    author: "Adnet Jacques",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "76",
    title: 'Фигурка "Пингвин", 1930-е годы, Франция, Керамическая фабрика г. Сен-Клеман, керамика, высота – 29 см, длина – 14 см.',
    img: "CHE_6289",
    view: "1",
    author: "SAINT-CLEMENT",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "63",
    title: '\u0424\u0438\u0433\u0443\u0440\u043a\u0430 "\u041c\u0430\u0440\u0430\u0431\u0443", 1930-\u0435 \u0433\u043e\u0434\u044b, \u0424\u0440\u0430\u043d\u0446\u0438\u044f, \u0430\u0432\u0442\u043e\u0440 \u2013 \u0413\u0430\u0431\u0440\u0438\u044d\u043b\u044c \u0411\u043e\u0432\u0435, \u0437\u0430\u043a\u0430\u0437\u0447\u0438\u043a - \u0441\u0442\u0443\u0434\u0438\u044f \u0434\u0438\u0437\u0430\u0439\u043d\u0430 Kaza, \u043a\u0435\u0440\u0430\u043c\u0438\u043a\u0430, \u0432\u044b\u0441\u043e\u0442\u0430 \u2013 30 \u0441\u043c, \u0434\u043b\u0438\u043d\u0430 \u2013 15 \u0441\u043c.',
    img: "CHE_2006",
    view: "1",
    author: "Beauvais Gabriel",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "31",
    title: 'Скульптура "Попугай", 1928 год, Нидерланды, Керамическая фабрика г. Гауда, автор – Крис ван дер Хёф, керамика, высота – 40 см, длина – 14 см.',
    img: "CHE_1970",
    view: "1",
    author: "Hoef Chris J. Van Der",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "50",
    title: 'Фигурка "Дятел", 1930-е годы, Бельгия, Императорская и Королевская мануфактура г. Ними, керамика, высота – 20 см, длина – 19 см.',
    img: "IMG_4218",
    view: "1",
    author: "Manufacture Imperiale et Royale Nimy",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "75",
    title: 'Фигурка "Пингвин", 1930-е годы, Франция, автор – Габриэль Бове, заказчик - студия дизайна Kaza, керамика, высота – 31 см, длина – 11 см.',
    img: "_DSC7322",
    view: "1",
    author: "Beauvais Gabriel",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "30",
    title: 'Скульптура "Пингвин", 1930-е годы, Франция, автор – Габриэль Бове, заказчик - студия дизайна Kaza, керамика, высота – 47 см, длина – 30 см.',
    img: "CHE_2074",
    view: "1",
    author: "Beauvais Gabriel",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "29",
    title: 'Скульптура "Пингвин", 1930 год, Франция, Керамическая фабрика г. Сен-Клеман, автор – Жорж Конде, керамика, высота – 46 см, длина – 17 см.',
    img: "CHE_7263",
    view: "1",
    author: "Conde Georges",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "28",
    title: 'Скульптура "Пингвин", 1930 год, Франция, Керамическая фабрика г. Сен-Клеман, автор – Жорж Конде, керамика, высота – 46 см, длина – 17 см.',
    img: "CHE_7202",
    view: "1",
    author: "Conde Georges",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "18",
    title: 'Скульптура "Павлин", 1930-е годы, Франция, автор – Габриэль Бове, заказчик - студия дизайна Kaza, керамика, высота – 29 см, длина – 60 см.',
    img: "CHE_2098",
    view: "1",
    author: "Beauvais Gabriel",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "62",
    title: 'Фигурка "Мандаринка", 1925 год, Франция, автор – Жак Адне, керамика, высота – 13 см, длина – 19 см.',
    img: "CHE_6264",
    view: "1",
    author: "Adnet Jacques",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "48",
    title: 'Фигурка "Голубь", 1925 год, Франция, автор – Жак Адне, керамика, высота – 20 см, длина – 19 см.',
    img: "CHE_2027",
    view: "1",
    author: "Adnet Jacques",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "35",
    title: 'Скульптура "Фазан", 1930-е годы, Франция, автор – Эдуард Казо (псевд. LUCE), керамика, высота – 30 см, длина – 68 см.',
    img: "CHE_6283",
    view: "1",
    author: "LUCE [Edouard Cazaux]",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "74",
    title: 'Фигурка "Петух", 1930-е годы, Франция, Керамическая фабрика братьев Мужан, керамика, высота – 32 см, длина – 20 см.',
    img: "CHE_1999",
    view: "1",
    author: "MOUGIN",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "50",
    title: "\u0424\u0438\u0433\u0443\u0440\u043a\u0430 '\u041f\u0435\u043b\u0438\u043a\u0430\u043d', 1930-\u0435 \u0433\u043e\u0434\u044b, \u0411\u0435\u043b\u044c\u0433\u0438\u044f, \u0418\u043c\u043f\u0435\u0440\u0430\u0442\u043e\u0440\u0441\u043a\u0430\u044f \u0438 \u041a\u043e\u0440\u043e\u043b\u0435\u0432\u0441\u043a\u0430\u044f \u043c\u0430\u043d\u0443\u0444\u0430\u043a\u0442\u0443\u0440\u0430 \u0433. \u041d\u0438\u043c\u0438, \u043a\u0435\u0440\u0430\u043c\u0438\u043a\u0430, \u0432\u044b\u0441\u043e\u0442\u0430 \u2013 13 \u0441\u043c, \u0434\u043b\u0438\u043d\u0430 \u2013 25 \u0441\u043c.",
    img: "CHE_6176",
    view: "1",
    author: "Manufacture Imperiale et Royale Nimy",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "78",
    title: 'Фигурка "Птица", 1930-е годы, Бельгия, Императорская и Королевская мануфактура г. Ними, керамика, высота – 26 см, длина – 27 см.',
    img: "CHE_2039",
    view: "1",
    author: "Manufacture Imperiale et Royale Nimy",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "52",
    title: 'Фигурка "Индюк", 1930-е годы, Франция, автор – Габриэль Бове (атрибуция), керамика, высота – 29 см, длина – 31 см.',
    img: "CHE_2071",
    view: "1",
    author: "Beauvais Gabriel",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "91",
    title: 'Фигурка "Тукан", 1930-е годы, Бельгия, Императорская и Королевская мануфактура г. Ними, керамика, высота – 22 см, длина – 21 см.',
    img: "CHE_7239",
    view: "1",
    author: "Manufacture Imperiale et Royale Nimy",
    creator: "animalism",
    type: "bird",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "47",
    title: 'Фигурка "Гитарист", 1930-е годы, Бельгия, фарфоровая мануфактура "Серабель" (г. Бодур), керамика, высота – 17 см, длина – 22 см.',
    img: "DSC_4420",
    view: "3",
    author: "CERABEL",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "96",
    title: "\u0424\u0438\u0433\u0443\u0440\u043a\u0430 \xab\u0411\u0430\u0440\u0430\u0431\u0430\u043d\u0449\u0438\u043a\xbb, 1930-\u0435 \u0433\u043e\u0434\u044b, \u0411\u0435\u043b\u044c\u0433\u0438\u044f, \u0444\u0430\u0440\u0444\u043e\u0440\u043e\u0432\u0430\u044f \u043c\u0430\u043d\u0443\u0444\u0430\u043a\u0442\u0443\u0440\u0430 '\u0421\u0435\u0440\u0430\u0431\u0435\u043b\u044c' (\u0433. \u0411\u043e\u0434\u0443\u0440), \u043a\u0435\u0440\u0430\u043c\u0438\u043a\u0430, \u0432\u044b\u0441\u043e\u0442\u0430 \u2013 18 \u0441\u043c, \u0434\u043b\u0438\u043d\u0430 \u2013 16 \u0441\u043c.",
    img: "CHE_6160",
    view: "3",
    author: "CERABEL",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "0"
  }, {
    id: "40",
    title: 'Фигурка "Аккордеонист", 1930-е годы, Франция, Керамическая фабрика Булонь-сюр-Сен, заказчик - студия дизайна Robj, керамика, высота – 19 см, длина – 14 см.',
    img: "CHE_7233",
    view: "3",
    author: "ROBJ",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "0",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "designStudio",
    designStudio: "0",
    factories: "0"
  }, {
    id: "80",
    title: 'Фигурка "Пьеро с "Куантро", 1920-е годы, Франция, автор – Жан-Адриен Мерсье, заказчик - студия дизайна Robj, керамика, высота – 26 см, длина – 13 см.',
    img: "CHE_1548",
    view: "3",
    author: "ROBJ",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "0",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "designStudio",
    designStudio: "0",
    factories: "0"
  }, {
    id: "96",
    title: "\u0424\u0438\u0433\u0443\u0440\u043a\u0430 '\u0423\u043c\u0438\u0440\u0430\u044e\u0449\u0438\u0439 \u043b\u0435\u0431\u0435\u0434\u044c' (\u0410\u043d\u043d\u0430 \u041f\u0430\u0432\u043b\u043e\u0432\u0430), 1930-\u0435 \u0433\u043e\u0434\u044b, \u0410\u0432\u0441\u0442\u0440\u0438\u044f, \u041a\u0435\u0440\u0430\u043c\u0438\u0447\u0435\u0441\u043a\u0430\u044f \u043c\u0430\u043d\u0443\u0444\u0430\u043a\u0442\u0443\u0440\u0430 \u0413\u043e\u043b\u044c\u0434\u0448\u0430\u0439\u0434\u0435\u0440, \u0430\u0432\u0442\u043e\u0440 \u2013 \u0421\u0442\u0435\u0444\u0430\u043d \u0414\u0430\u043a\u043e\u043d, \u043a\u0435\u0440\u0430\u043c\u0438\u043a\u0430, \u0432\u044b\u0441\u043e\u0442\u0430 \u2013 18 \u0441\u043c, \u0434\u043b\u0438\u043d\u0430 \u2013 28 \u0441\u043c.",
    img: "CHE_6155",
    view: "3",
    author: "DAKON STEPHAN",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "77",
    title: 'Фигурка "Пойманная птица", 1930-е годы, Австрия, Керамическая мануфактура Голдшайдер, автор – Йозеф Лоренцл, керамика, высота – 31 см, длина – 26 см.',
    img: "CHE_7211+1",
    view: "1",
    author: "LORENZl Josef",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "60",
    title: 'Фигурка "Леди Ар-деко", 1930-е годы, Франция, Севрская фарфоровая мануфактура, керамика, высота – 27 см, длина – 17 см.',
    img: "CHE_1558",
    view: "3",
    author: "SEVRES",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "0",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "34",
    title: 'Скульптура "Танцовщица фламенко", 1928 год, Франция, Керамическая фабрика "Виллерой и Бох де Сетфонтэн" (Люксембург), автор – Е. Маржери, заказчик - студия дизайна Robj, керамика, высота – 40 см, длина – 25 см.',
    img: "DSC_4429",
    view: "2",
    author: "ROBJ",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "0",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "designStudio",
    designStudio: "0",
    factories: "0"
  }, {
    id: "39",
    title: 'Фигурка "3 матроса", 1931 год, Франция, Керамическая фабрика "Виллерой и Бох де Сетфонтэн" (Люксембург), заказчик - студия дизайна Robj, керамика, высота – 29 см, длина – 34 см.',
    img: "DSC_4455",
    view: "3",
    author: "ROBJ",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "0",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "designStudio",
    designStudio: "0",
    factories: "0"
  }, {
    id: "38",
    title: 'Фигурка "3 матроса", 1930-е годы, Франция, авторы – Лежан (Ивонн Жан-Афен и Эльвира Куюмуджан), керамика, высота – 29 см, длина – 33 см.',
    img: "CHE_7278",
    view: "3",
    author: "Lejan (Yvonne Jean-Haffen & Elvire Kouyoumojian)",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "94",
    title: "\u0424\u0438\u0433\u0443\u0440\u043a\u0430 \xab2 \u043c\u0430\u0442\u0440\u043e\u0441\u0430\xbb, 1930-\u0435 \u0433\u043e\u0434\u044b, \u0424\u0440\u0430\u043d\u0446\u0438\u044f, \u0430\u0432\u0442\u043e\u0440 \u2013 \u042d\u0434\u0443\u0430\u0440\u0434 \u041a\u0430\u0437\u043e (\u043f\u0441\u0435\u0432\u0434. DAX), \u043a\u0435\u0440\u0430\u043c\u0438\u043a\u0430, \u0432\u044b\u0441\u043e\u0442\u0430 \u2013 34 \u0441\u043c, \u0434\u043b\u0438\u043d\u0430 \u2013 21 \u0441\u043c.",
    img: "CHE_7280_1",
    view: "3",
    author: "DAX [Edouard Cazaux]",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "15",
    title: 'Скульптура "Матрос с аккордеоном", 1930-е годы, Франция, автор – Марсель-Андре Бурен, керамика, высота – 38 см, длина – 25 см.',
    img: "CHE_6261",
    view: "2",
    author: "Bouraine Marcel-Andre",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "16",
    title: 'Скульптура "Обнаженная с шалью", 1930 год, Франция, Керамическая фабрика "Виллерой и Бох де Сетфонтэн" (Люксембург), автор – Вячеслав Гарин, керамика, высота – 44 см, длина – 23 см.',
    img: "CHE_1541",
    view: "2",
    author: "Garine Viatcheslav",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "96",
    title: "\u0421\u043a\u0443\u043b\u044c\u043f\u0442\u0443\u0440\u0430 \xab\u0428\u0451\u043b\u043a\xbb, 1930-\u0435 \u0433\u043e\u0434\u044b, \u0424\u0440\u0430\u043d\u0446\u0438\u044f, \u041a\u0435\u0440\u0430\u043c\u0438\u0447\u0435\u0441\u043a\u0430\u044f \u0444\u0430\u0431\u0440\u0438\u043a\u0430 \u0433. \u0411\u0443\u043b\u043e\u043d\u044c-\u0421\u044e\u0440-\u0421\u0435\u043d, \u0430\u0432\u0442\u043e\u0440 \u2013 \u041a\u043b\u043e\u0434-\u041c\u0430\u0440\u0441\u0435\u043b\u044c \u0420\u0435\u043d\u0430\u0440, \u043a\u0435\u0440\u0430\u043c\u0438\u043a\u0430, \u0432\u044b\u0441\u043e\u0442\u0430 \u2013 48 \u0441\u043c, \u0434\u043b\u0438\u043d\u0430 \u2013 22 \u0441\u043c.",
    img: "CHE_7520",
    view: "3",
    author: "RENARD CLAUDE-MARCEL",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "96",
    title: "\u0424\u0438\u0433\u0443\u0440\u043a\u0430 \xab\u0412\u0435\u0441\u043d\u0430\xbb, 1930-\u0435 \u0433\u043e\u0434\u044b, \u0424\u0440\u0430\u043d\u0446\u0438\u044f, \u0430\u0432\u0442\u043e\u0440 \u2013 \u0420\u044d\u0439\u043c\u043e\u043d\u0434 \u0413\u0435\u0440\u0431, \u043a\u0435\u0440\u0430\u043c\u0438\u043a\u0430, \u0432\u044b\u0441\u043e\u0442\u0430 \u2013 32 \u0441\u043c, \u0434\u043b\u0438\u043d\u0430 \u2013 14 \u0441\u043c.",
    img: "CHE_6166",
    view: "3",
    author: "GUERBE RAYMONDE",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "32",
    title: 'Скульптура "Сидящая обнаженная", 1929 год, Бельгия, автор – Анджело Хек, керамика, высота – 42 см, длина – 20 см.',
    img: "IMG_4210",
    view: "2",
    author: "HECQ ANGELO",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "90",
    title: 'Фигурка "Танцовщица", 1930-е годы, Франция, автор – Клод Леви, заказчик - Primavera (студия дизайна парижского универмага Printemps), керамика, высота – 29 см, длина – 15 см.',
    img: "CHE_6294",
    view: "3",
    author: "LEVY CLAUDE",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "97",
    title: 'Фигурки «Пьеро» и «Коломбина», 1930-е годы, Франция, Керамическая фабрика г. Орши, автор – Эдуард Казо (псевд. DAX), керамика, высота – 32 см, длина – 14 см.',
    img: "DSC_4435",
    view: "3",
    author: "DAX [Edouard Cazaux]",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "96",
    title: 'Фигурки «Арлекин» и «Коломбина», 1930-е годы, Франция, Керамическая фабрика г. Орши, автор – Эдуард Казо (псевд. DAX), керамика, высота – 34 см, длина – 14 см.',
    img: "CHE_2067",
    view: "3",
    author: "DAX [Edouard Cazaux]",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "96",
    title: "\u0424\u0438\u0433\u0443\u0440\u043a\u0430 \xab\u0410\u0440\u043b\u0435\u043a\u0438\u043d\xbb, 1930-\u0435 \u0433\u043e\u0434\u044b, \u0424\u0440\u0430\u043d\u0446\u0438\u044f, \u041a\u0435\u0440\u0430\u043c\u0438\u0447\u0435\u0441\u043a\u0430\u044f \u0444\u0430\u0431\u0440\u0438\u043a\u0430 \u0433. \u041e\u0440\u0448\u0438, \u0430\u0432\u0442\u043e\u0440 \u2013 \u042d\u0434\u0443\u0430\u0440\u0434 \u041a\u0430\u0437\u043e (\u043f\u0441\u0435\u0432\u0434. DAX), \u043a\u0435\u0440\u0430\u043c\u0438\u043a\u0430, \u0432\u044b\u0441\u043e\u0442\u0430 \u2013 35 \u0441\u043c, \u0434\u043b\u0438\u043d\u0430 \u2013 17 \u0441\u043c.",
    img: "CHE_6150",
    view: "3",
    author: "DAX [Edouard Cazaux]",
    creator: "figurativeSculpture",
    type: "figurativeSculpture",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "27",
    title: 'Скульптура "Парусник", 1930-е годы, Франция, авторы – Лежан (Ивонн Жан-Афен и Эльвира Куюмуджан), керамика, высота – 49 см, длина – 38 см.',
    img: "CHE_1968",
    view: "2",
    author: "Lejan (Yvonne Jean-Haffen & Elvire Kouyoumojian)",
    creator: "ship",
    type: "ship",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "1",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "79",
    title: 'Фигурка "Пудель", 1930-е годы, Франция, автор – Жак Адне, керамика, высота – 26 см, длина – 32 см.',
    img: "CHE_1998",
    view: "1",
    author: "Adnet Jacques",
    creator: "animalism",
    type: "dog",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "6",
    title: 'Скульптура "Борзая", 1930-е годы, Франция, авторы – Лежан (Ивонн Жан-Афен и Эльвира Куюмуджан), керамика, высота – 43 см, длина – 56 см.',
    img: "_DSC7321",
    view: "1",
    author: "Lejan (Yvonne Jean-Haffen & Elvire Kouyoumojian)",
    creator: "animalism",
    type: "dog",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "8",
    title: 'Скульптура "Дама с борзой", 1930-е годы, Франция, автор - Жорж Лаврофф (Георгий Дмитриевич Лавров) (1895-1991), керамика, высота – 27 см, длина – 69 см.',
    img: "CHE_2090",
    view: "1",
    author: "Lavroff Georges",
    creator: "sculptureComposition",
    type: "sculptureComposition",
    animalism: "0",
    figurativeSculpture: "0",
    sculptureComposition: "1",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "17",
    title: 'Скульптура "Охота на оленя", 1930-е годы, Франция, автор – Ирен Рошар, шпиатр, мрамор, высота – 50 см, длина – 73 см.',
    img: "VCH_5221",
    view: "1",
    author: "Rochard Irene",
    creator: "sculptureComposition",
    type: "sculptureComposition",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "26",
    title: 'Скульптура "Парусник", 1930 год, Франция, Керамическая фабрика г. Сен-Клеман, автор – Жорж Конде, керамика, высота – 46 см, длина – 32 см.',
    img: "CHE_6256",
    view: "2",
    author: "Conde Georges",
    creator: "ship",
    type: "ship",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "1",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "82",
    title: 'Фигурка "Слон", 1925 год, Франция, Керамическая фабрика кантона Лонгви, автор – Клод Леви, заказчик - Primavera (студия дизайна парижского универмага Printemps), керамика, высота – 19 см, длина – 25 см.',
    img: "CHE_1571",
    view: "1",
    author: "LEVY CLAUDE",
    creator: "animalism",
    type: "elephant",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "83",
    title: 'Фигурка "Слон", 1925 год, Франция, Керамическая фабрика кантона Лонгви, автор – Клод Леви, заказчик - Primavera (студия дизайна парижского универмага Printemps), керамика, высота – 19 см, длина – 25 см.',
    img: "CHE_7268",
    view: "1",
    author: "LEVY CLAUDE",
    creator: "animalism",
    type: "elephant",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "84",
    title: 'Фигурка "Слон", 1930 год, Франция, Керамическая фабрика г. Сен-Клеман, автор – Шарль Лемансо, керамика, высота – 18 см, длина – 22 см.',
    img: "CHE_7267",
    view: "1",
    author: "LEMANCEAU CHARLES",
    creator: "animalism",
    type: "elephant",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "37",
    title: 'Скульптуры "Слониха со слоненком", 1930-е годы, Франция, Керамическая фабрика г. Сен-Клеман, автор – Шарль Лемансо, керамика, высота – 36(22) см, длина – 51(33) см.',
    img: "DSC_4452",
    view: "1",
    author: "LEMANCEAU CHARLES",
    creator: "animalism",
    type: "elephant",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "59",
    title: 'Фигурка "Кролик" из 2-х частей (основание с емкостью и крышка в форме кролика), 1930 год, Франция, Керамическая фабрика г. Сен-Клеман, автор – Шарль Лемансо, керамика, высота – 15 см, длина – 28 см.',
    img: "CHE_2051",
    view: "1",
    author: "LEMANCEAU CHARLES",
    creator: "animalism",
    type: "rabbit",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "45",
    title: 'Фигурка "Бык", 1930-е годы, Франция, автор – Морис Себастьян Лоран, керамика, высота – 23 см, длина – 28 см.',
    img: "IMG_4196",
    view: "1",
    author: "Laurent Maurice-Sebastien",
    creator: "animalism",
    type: "artiodactyls",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "46",
    title: 'Фигурка "Газель", 1930 год, Франция, Керамическая фабрика г. Сен-Клеман, автор – Шарль Лемансо, керамика, высота – 29 см, длина – 31 см.',
    img: "_DSC7316",
    view: "1",
    author: "LEMANCEAU CHARLES",
    creator: "animalism",
    type: "artiodactyls",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "41",
    title: 'Фигурка "Белка", 1930 год, Франция, Керамическая фабрика г. Сен-Клеман, автор – Шарль Лемансо, керамика, высота – 30 см, длина – 22 см.',
    img: "CHE_2016",
    view: "1",
    author: "LEMANCEAU CHARLES",
    creator: "animalism",
    type: "squirell",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "51",
    title: 'Фигурка "Заяц", 1930-е годы, Бельгия, Императорская и Королевская мануфактура г. Ними, керамика, высота – 12 см, длина – 38 см.',
    img: "CHE_7261",
    view: "1",
    author: "Manufacture Imperiale et Royale Nimy",
    creator: "animalism",
    type: "rabbit",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "7",
    title: 'Скульптура "Георгий Победоносец, поражающий змея", 1930-е годы, Франция, автор – Габриэль Бове, заказчик - студия дизайна Kaza, керамика, высота – 40 см, длина – 73 см.',
    img: "CHE_1573",
    view: "2",
    author: "Beauvais Gabriel",
    creator: "sculptureComposition",
    type: "sculptureComposition",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "69",
    title: 'Фигурка "Носорог", 1930-е годы, Франция, Керамическая фабрика братьев Мужан, керамика, высота – 19 см, длина – 35 см.',
    img: "CHE_6285",
    view: "1",
    author: "MOUGIN",
    creator: "animalism",
    type: "rhinoceros",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "68",
    title: 'Фигурка "Носорог", 1930-е годы, Франция, авторы – ОДИВ (Одетта Берло и Ивонн Мюсье), керамика, высота – 17 см, длина – 28 см.',
    img: "DSC_4425",
    view: "1",
    author: "ODYV (Odette Berlot & Yvonne Mussier)",
    creator: "animalism",
    type: "rhinoceros",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "70",
    title: 'Фигурка "Носорог", 1930-е годы, Франция, Керамическая фабрика братьев Мужан, керамика, высота – 21 см, длина – 37 см.',
    img: "CHE_6286",
    view: "1",
    author: "MOUGIN",
    creator: "animalism",
    type: "rhinoceros",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "73",
    title: 'Фигурка "Пекинес", 1930-е годы, Франция, Керамическая фабрика г. Булонь-Сюр-Мер, керамика, высота – 17 см, длина – 25 см.',
    img: "CHE_2058",
    view: "1",
    author: "BOULOGNE-SUR-MER",
    creator: "animalism",
    type: "dog",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "81",
    title: 'Фигурка "Рыбка", 1930-е годы, Франция, фабрика художественного стекла Сабино, стекло, высота – 9 см, длина – 18 см.',
    img: "VCH_5201",
    view: "1",
    author: "SABINO",
    creator: "animalism",
    type: "fish",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "36",
    title: 'Скульптура-ваза "Рыбы", 1930-е годы, Франция, автор – Мариан Клузо, керамика, высота – 24 см, длина – 52 см.',
    img: "CHE_7253",
    view: "1",
    author: "Clouzot Marianne",
    creator: "animalism",
    type: "fish",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "33",
    title: 'Скульптура "Скакуны", 1923 год, Франция, автор – Клод Леви, заказчик - Primavera (студия дизайна парижского универмага Printemps), керамика, высота – 28 см, длина – 56 см.',
    img: "CHE_1540",
    view: "1",
    author: "LEVY CLAUDE",
    creator: "animalism",
    type: "horse",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "33",
    title: "\u0421\u043a\u0443\u043b\u044c\u043f\u0442\u0443\u0440\u0430 '\u0421\u043a\u0430\u043a\u0443\u043d\u044b', 1923 \u0433\u043e\u0434, \u0424\u0440\u0430\u043d\u0446\u0438\u044f, \u0430\u0432\u0442\u043e\u0440 \u2013 \u041a\u043b\u043e\u0434 \u041b\u0435\u0432\u0438, \u0437\u0430\u043a\u0430\u0437\u0447\u0438\u043a - Primavera (\u0441\u0442\u0443\u0434\u0438\u044f \u0434\u0438\u0437\u0430\u0439\u043d\u0430 \u043f\u0430\u0440\u0438\u0436\u0441\u043a\u043e\u0433\u043e \u0443\u043d\u0438\u0432\u0435\u0440\u043c\u0430\u0433\u0430 Printemps), \u043a\u0435\u0440\u0430\u043c\u0438\u043a\u0430, \u0432\u044b\u0441\u043e\u0442\u0430 \u2013 29 \u0441\u043c, \u0434\u043b\u0438\u043d\u0430 \u2013 58 \u0441\u043c.",
    img: "CHE_6148",
    view: "1",
    author: "LEVY CLAUDE",
    creator: "animalism",
    type: "horse",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "86",
    title: 'Фигурка "Слон", 1930-е годы, Бельгия, Императорская и Королевская мануфактура г. Ними, автор – Альберт Аебли, керамика, высота – 15 см, длина – 17 см.',
    img: "_DSC7341",
    view: "1",
    author: "Aebly Albert",
    creator: "animalism",
    type: "elephant",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "87",
    title: 'Фигурка "Слон", 1930-е годы, Дания, Датская Королевская фарфоровая мануфактура, автор – Кнуд Кун, керамика, высота – 10 см, длина – 14 см.',
    img: "CHE_7290",
    view: "1",
    author: "KYHN KNUD",
    creator: "animalism",
    type: "elephant",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "85",
    title: '\u0424\u0438\u0433\u0443\u0440\u043a\u0430 "\u0421\u043b\u043e\u043d", 1930-\u0435 \u0433\u043e\u0434\u044b, \u0411\u0435\u043b\u044c\u0433\u0438\u044f, \u0418\u043c\u043f\u0435\u0440\u0430\u0442\u043e\u0440\u0441\u043a\u0430\u044f \u0438 \u041a\u043e\u0440\u043e\u043b\u0435\u0432\u0441\u043a\u0430\u044f \u043c\u0430\u043d\u0443\u0444\u0430\u043a\u0442\u0443\u0440\u0430 \u0433. \u041d\u0438\u043c\u0438, \u0430\u0432\u0442\u043e\u0440 \u2013 \u0410\u043b\u044c\u0431\u0435\u0440\u0442 \u0410\u0435\u0431\u043b\u0438, \u043a\u0435\u0440\u0430\u043c\u0438\u043a\u0430, \u0432\u044b\u0441\u043e\u0442\u0430 \u2013 15 \u0441\u043c, \u0434\u043b\u0438\u043d\u0430 \u2013 17 \u0441\u043c.',
    img: "CHE_7319",
    view: "1",
    author: "Aebly Albert",
    creator: "animalism",
    type: "elephant",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }, {
    id: "88",
    title: 'Фигурка "Слон", 1930-е годы, Франция, фабрика художественного стекла Сабино, стекло, высота – 11 см, длина – 8 см.',
    img: "DSC_4454",
    view: "1",
    author: "SABINO",
    creator: "animalism",
    type: "elephant",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "93",
    title: 'Фигурка "Шотландский терьер", 1930-е годы, Франция, Керамическая фабрика г. Сен-Клеман, керамика, высота – 16 см, длина – 14 см.',
    img: "CHE_7195",
    view: "1",
    author: "SAINT-CLEMENT",
    creator: "animalism",
    type: "dog",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "factories",
    designStudio: "0",
    factories: "1"
  }, {
    id: "89",
    title: 'Фигурка "Собака", 1930-е годы, Франция, автор – Жак Адне, керамика, высота – 27 см, длина – 16 см.',
    img: "DSC_4423",
    view: "1",
    author: "Adnet Jacques",
    creator: "animalism",
    type: "dog",
    animalism: "1",
    figurativeSculpture: "0",
    sculptureComposition: "0",
    ships: "0",
    filterType: "authors",
    designStudio: "0",
    factories: "0"
  }],
  filter: {
    animalism: {
      name: 'animalism',
      title: 'Анималистика',
      paginationNumber: '0',
      item: [{
          name: 'squirell',
          title: 'Белки'
        },
        {
          name: 'rabbit',
          title: 'Зайцы/Кролики'
        },
        {
          name: 'cat',
          title: 'Кошки'
        },
        {
          name: 'horse',
          title: 'Лошади'
        },
        {
          name: 'bear',
          title: 'Медведи'
        },
        {
          name: 'rhinoceros',
          title: 'Носороги'
        },
        {
          name: 'artiodactyls',
          title: 'Парнокопытные'
        },
        {
          name: 'bird',
          title: 'Птицы'
        },
        {
          name: 'fish',
          title: 'Рыбы'
        },
        {
          name: 'elephant',
          title: 'Слоны'
        },
        {
          name: 'dog',
          title: 'Собаки'
        }
      ]
    },
    ship: {
      name: 'ship',
      title: 'Корабли',
      paginationNumber: '0',
    },
    sculptureComposition: {
      name: 'sculptureComposition',
      title: 'Скульптурная композиция',
      paginationNumber: '0',
    },
    figurativeSculpture: {
      name: 'figurativeSculpture',
      title: 'Фигуративная скульптура',
      paginationNumber: '0',
    },
    authors: {
      name: 'authors',
      title: 'Авторы',
      paginationNumber: '0',
      item: [{
          "name": "LEMANCEAU CHARLES",
          "title": "LEMANCEAU CHARLES"
        },
        {
          "name": "Siegl",
          "title": "Siegl"
        },
        {
          "name": "ODYV (Odette Berlot & Yvonne Mussier)",
          "title": "ODYV (Odette Berlot & Yvonne Mussier)"
        },
        {
          "name": "HECQ ANGELO",
          "title": "HECQ ANGELO"
        },
        {
          "name": "D’Yerna",
          "title": "D’Yerna"
        },
        {
          "name": "Lejan (Yvonne Jean-Haffen & Elvire Kouyoumojian)",
          "title": "Lejan (Yvonne Jean-Haffen & Elvire Kouyoumojian)"
        },
        {
          "name": "Pierre E.",
          "title": "Pierre E."
        },
        {
          "name": "Martel Jan & Joel",
          "title": "Martel Jan & Joel"
        },
        {
          "name": "Sandoz Edouard-Marcel",
          "title": "Sandoz Edouard-Marcel"
        },
        {
          "name": "Tavernier Lise",
          "title": "Tavernier Lise"
        },
        {
          "name": "Adnet Jacques",
          "title": "Adnet Jacques"
        },
        {
          "name": "Tharaud Camille",
          "title": "Tharaud Camille"
        },
        {
          "name": "Chassaing Edouard",
          "title": "Chassaing Edouard"
        },
        {
          "name": "Aebly Albert",
          "title": "Aebly Albert"
        },

        {
          "name": "Fontinelle Jean de La",
          "title": "Fontinelle Jean de La"
        },
        {
          "name": "Desbarbieux",
          "title": "Desbarbieux"
        },
        {
          "name": "Ireland",
          "title": "Ireland"
        },
        {
          "name": "Catteau Charles",
          "title": "Catteau Charles"
        },
        {
          "name": "Hoef Chris J. Van Der",
          "title": "Hoef Chris J. Van Der"
        },
        {
          "name": "Beauvais Gabriel",
          "title": "Beauvais Gabriel"
        },
        {
          "name": "Conde Georges",
          "title": "Conde Georges"
        },
        {
          "name": "LUCE [Edouard Cazaux]",
          "title": "LUCE [Edouard Cazaux]"
        },
        {
          "name": "DAKON STEPHAN",
          "title": "DAKON STEPHAN"
        },
        {
          "name": "LORENZl Josef",
          "title": "LORENZl Josef"
        },
        {
          "name": "DAX [Edouard Cazaux]",
          "title": "DAX [Edouard Cazaux]"
        },
        {
          "name": "Bouraine Marcel-Andre",
          "title": "Bouraine Marcel-Andre"
        },
        {
          "name": "Garine Viatcheslav",
          "title": "Garine Viatcheslav"
        },
        {
          "name": "RENARD CLAUDE-MARCEL",
          "title": "RENARD CLAUDE-MARCEL"
        },
        {
          "name": "GUERBE RAYMONDE",
          "title": "GUERBE RAYMONDE"
        },
        {
          "name": "LEVY CLAUDE",
          "title": "LEVY CLAUDE"
        },
        {
          "name": "Lavroff Georges",
          "title": "Lavroff Georges"
        },
        {
          "name": "Rochard Irene",
          "title": "Rochard Irene"
        },
        {
          "name": "Laurent Maurice-Sebastien",
          "title": "Laurent Maurice-Sebastien"
        },
        {
          "name": "Clouzot Marianne",
          "title": "Clouzot Marianne"
        },
        {
          "name": "KYHN KNUD",
          "title": "KYHN KNUD"
        }
      ]

    },
    designStudio: {
      name: 'designStudio',
      title: 'дизайн-студии',
      paginationNumber: '0',
      item: [{
          name: 'CAF (Compagnie des Arts francais)',
          title: 'CAF (COMPAGNIE DES ARTS FRANCAIS) (ФРАНЦИЯ)'
        },
        {
          name: 'PRIMAVERA',
          title: 'PRIMAVERA (ФРАНЦИЯ)'
        },
        {
          name: 'ROBJ',
          title: 'ROBJ (ФРАНЦИЯ)'
        }
      ]
    },
    factories: {
      name: 'factories',
      title: 'фабрики',
      paginationNumber: '0',
      item: [{
          "name": "BOULOGNE-SUR-MER",
          "title": "BOULOGNE-SUR-MER (Франция)"
        },
        {
          "name": "SABINO",
          "title": "SABINO (Франция)"
        },
        {
          "name": "Manufacture Imperiale et Royale Nimy",
          "title": "Manufacture Imperiale et Royale Nimy (Бельгия)"
        },
        {
          "name": "SAINT-CLEMENT",
          "title": "SAINT-CLEMENT (Франция)"
        },
        {
          "name": "SEVRES",
          "title": "SEVRES (Франция)"
        },
        {
          "name": "MOUGIN",
          "title": "MOUGIN (Франция)"
        },

        {
          "name": "CERABEL",
          "title": "CERABEL (Бельгия)"
        },
        {
          "name": "N.V. KONINKLIJKE PLATEELBAKKERIJ ZUID-HOLLAND, GOUDA",
          "title": "N.V. KONINKLIJKE PLATEELBAKKERIJ ZUID-HOLLAND, GOUDA (НИДЕРЛАНДЫ)"
        }
      ]
    }

  },
};

export default sculptures;